/**
 * Filter dropdowns cache their values until a record is added or updated.
 * Apply, Clear All, paging, and page size reload the table and leave this
 * version alone. A save reload bumps listingOptionsVersion, and the next
 * open of a dropdown fetches again.
 *
 * Returns 0 until the list is on screen, then 1 plus the number of save reloads.
 * Version 1 is what lets a pinned filter with a value load as the page appears.
 */
export default function useListingOptionsVersion(slice, listKey, listData) {
  if (typeof listData === "undefined") {
    return 0;
  }
  const recordChanges = slice?.listingOptionsVersion?.[listKey];
  const changes = typeof recordChanges === "number" ? recordChanges : 0;
  return 1 + changes;
}
